import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

const Reunioes = (props) => {
	//meta title
	document.title = "Senda | Reunioes";

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumbs
						title={props.t("Reunioes")}
						breadcrumbItem={props.t("Reunioes")}
					/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withTranslation()(Reunioes);
